
export default {
  name: 'YoutubeRegionRestrictionChecker',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Can I use the YouTube region restriction checker on other platforms?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The bad news is no! This tool only works with YouTube videos. So you can't utilize it on other platforms. Yet, you can use other tools to check the video's availability in your country. For example, consider using a VPN to change your location and watch the video."
          }
        },
        {
          "@type": "Question",
          "name": "How do I bypass YouTube location restrictions?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Some ways to bypass these location restrictions and access the content you want exist. For example, you can use a virtual private network (VPN), a proxy server, or a browser extension."
          }
        },
        {
          "@type": "Question",
          "name": "Does YouTube have regional restrictions?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The answer is yes! This platform has regional restrictions. The reason for these limitations is that the platform has to comply with copyright laws and other legal regulations in different countries."
          }
        },
        {
          "@type": "Question",
          "name": "How do you check if a YouTube video is restricted?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Checking if a YouTube video is restricted is relatively easy. You can check the video title, description, or URL to know if it's limited. If you encounter a restricted video, you can turn off the Restricted Mode or meet the requirements mentioned in the video description."
          }
        },
        {
          "@type": "Question",
          "name": "How long does it take to check restrictions on YouTube?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The time it takes to check restrictions on YouTube depends on several factors, including the length of the video, the video quality, the amount of content uploaded at that time. The automated system generally takes a few minutes to several hours to check for restrictions, while the manual review process can take several days."
          }
        }
      ]
    };
  },
  data () {
    return {
      data: '',
      form: this.$vform({
        url: null
      })
    }
  },
  methods: {
    YoutubeRegionRestrictionChecker() {
        this.form.post(`/tool/youtube-region-restriction-checker`, { progress: false }).then(res => {
          this.data = res.data;
        }).catch(e => {
          console.log(e);
        });
    },
    onSample(){
        this.form.url = 'https://youtu.be/xN1WOlptE58';
    },
    onReset(){
        this.form.reset();
        this.data = null;
    }
  }
}
